import React from 'react'
import { required, SelectInput, SelectInputProps } from 'react-admin'
import { ADMINS_FIELDS } from '../../../providers/localization/constant'

const defaultProps = {
  label: `${ADMINS_FIELDS}.access_level.label`,
  source: 'access_level',
  choices: [
    { id: 'a', name: `${ADMINS_FIELDS}.access_level.choices.all_branches` },
    { id: 's', name: `${ADMINS_FIELDS}.access_level.choices.some_branches` },
  ],
}

export const AccessLevelSelectInput: React.FC<SelectInputProps> = ({
  label,
  source,
  choices,
  ...props
}) => {
  return (
    <SelectInput
      margin='none'
      fullWidth
      label={label}
      source={source}
      choices={choices}
      validate={[required()]}
      {...props}
    />
  )
}

AccessLevelSelectInput.defaultProps = defaultProps
